document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".prolab-become-distributor").forEach((section) => {
    const form = section.querySelector(".prolab-become-distributor__form");
    if (!form) return;

    const steps = Array.from(section.querySelectorAll(".prolab-become-distributor__step"));
    const next = section.querySelector(".prolab-become-distributor__next");
    const prev = section.querySelector(".prolab-become-distributor__prev");
    const submit = section.querySelector(".prolab-become-distributor__submit");
    const progress = section.querySelector(".prolab-become-distributor__progress-fill");
    const circles = Array.from(section.querySelectorAll(".prolab-become-distributor__progress-step"));
    const sidebarLinks = Array.from(section.querySelectorAll(".prolab-become-distributor__sidebar-link"));
    let toast = document.getElementById("global-form-toast");

    if (!toast) {
    toast = document.createElement("div");
    toast.id = "global-form-toast";
    toast.className = "form-toast";
    document.body.appendChild(toast);
    }

    let current = 0;

    function showToast(message) {
        let globalToast = document.getElementById("global-form-toast");

        if (!globalToast) {
            globalToast = document.createElement("div");
            globalToast.id = "global-form-toast";
            globalToast.className = "form-toast";
            document.body.appendChild(globalToast);
        }

        globalToast.textContent = message;
        globalToast.classList.remove("show");

        requestAnimationFrame(() => {
            globalToast.classList.add("show");
        });

        clearTimeout(globalToast._timer);
        globalToast._timer = setTimeout(() => {
            globalToast.classList.remove("show");
        }, 3500);
        }

    function getFieldLabel(field) {
      const wrap = field.closest(".prolab-become-distributor__field");
      const label = wrap?.querySelector(".prolab-become-distributor__field-label");
      return label ? label.textContent.replace("*", "").trim() : "Ce champ";
    }

    function getRequiredMessage(field) {
      const name = (field.name || "").toLowerCase();
      const label = getFieldLabel(field).toLowerCase();

      if (name.includes("first") || label.includes("prénom")) return "Le prénom est obligatoire.";
      if (name.includes("last") || label === "nom" || label.includes("nom")) return "Le nom est obligatoire.";
      if (name.includes("email") || label.includes("courriel")) return "Le courriel est obligatoire.";
      if (name.includes("phone") || label.includes("téléphone")) return "Le téléphone est obligatoire.";

      return `${getFieldLabel(field)} est obligatoire.`;
    }

    function setLoading(state) {
      form.classList.toggle("form-loading", state);
      form.querySelectorAll("input, textarea, select, button").forEach((el) => {
        el.disabled = state;
      });
    }

    function validateStep(stepEl) {
      const requiredFields = Array.from(stepEl.querySelectorAll("[required]"));
      let valid = true;
      let firstErrorMessage = "";
      const processedNames = new Set();

      requiredFields.forEach((field) => {
        field.classList.remove("field-error");
        field.closest("label")?.classList.remove("field-error");

        if (field.type === "radio" || field.type === "checkbox") {
          if (processedNames.has(field.name)) return;
          processedNames.add(field.name);

          const group = Array.from(stepEl.querySelectorAll(`[name="${CSS.escape(field.name)}"]`));
          const checked = group.some((item) => item.checked);

          if (!checked) {
            valid = false;
            if (!firstErrorMessage) firstErrorMessage = getRequiredMessage(field);
            group.forEach((item) => item.closest("label")?.classList.add("field-error"));
          }

          return;
        }

        if (field.tagName === "SELECT" && !field.value) {
          valid = false;
          if (!firstErrorMessage) firstErrorMessage = getRequiredMessage(field);
          field.classList.add("field-error");
          return;
        }

        if (!field.value || !field.value.trim()) {
          valid = false;
          if (!firstErrorMessage) firstErrorMessage = getRequiredMessage(field);
          field.classList.add("field-error");
          return;
        }

        if (field.type === "email") {
          const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value.trim());

          if (!emailOk) {
            valid = false;
            if (!firstErrorMessage) firstErrorMessage = "Le courriel est invalide.";
            field.classList.add("field-error");
          }
        }
      });

      if (!valid && firstErrorMessage) {
        showToast(firstErrorMessage);
      }

      return valid;
    }

    function updateSidebar(stepId) {
      sidebarLinks.forEach((link) => {
        link.classList.toggle("is-active", link.getAttribute("data-go-step") === stepId);
      });
    }

    function showStep() {
      if (!steps.length) return;

      steps.forEach((step, index) => {
        step.classList.toggle("active", index === current);
      });

      circles.forEach((circle, index) => {
        circle.classList.toggle("active", index <= current);
      });

      const activeStepId = steps[current]?.getAttribute("data-step-id");
      updateSidebar(activeStepId);

      if (progress && steps.length > 1) {
        progress.style.width = `${(current / (steps.length - 1)) * 100}%`;
      } else if (progress) {
        progress.style.width = "100%";
      }

      if (prev) prev.style.display = current === 0 ? "none" : "inline-flex";
      if (next) next.style.display = current === steps.length - 1 ? "none" : "inline-flex";
      if (submit) submit.style.display = current === steps.length - 1 ? "inline-flex" : "none";
    }

    next?.addEventListener("click", () => {
      if (!validateStep(steps[current])) return;

      if (current < steps.length - 1) {
        current++;
        showStep();
      }
    });

    prev?.addEventListener("click", () => {
      if (current > 0) {
        current--;
        showStep();
      }
    });

    sidebarLinks.forEach((link) => {
      link.addEventListener("click", () => {
        const targetId = link.getAttribute("data-go-step");
        const targetIndex = steps.findIndex((step) => step.getAttribute("data-step-id") === targetId);

        if (targetIndex !== -1) {
          current = targetIndex;
          showStep();
        }
      });
    });

    const revealTargets = Array.from(section.querySelectorAll(".reveal-on-scroll"));
    revealTargets.forEach((el) => el.classList.add("is-visible"));

    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      if (!validateStep(steps[current])) return;

      const formData = new FormData(form);

      try {
        setLoading(true);

        const res = await fetch("https://sinto-one-prolab-327c8bdb5bc4.herokuapp.com/public-api/become-distributor", {
          method: "POST",
          body: formData,
        });

        if (res.ok) {
          showToast("✅ Demande envoyée avec succès !");
          form.reset();
          current = 0;
          showStep();
        } else {
          showToast("Erreur lors de l’envoi.");
        }
      } catch (error) {
        showToast("Erreur réseau.");
      } finally {
        setLoading(false);
      }
    });

    showStep();
  });
});